import React from 'react'
import classnames from 'classnames'
import ScrollElememt from '../../../../components/ScrollElement'

import './style.scss'

interface BlockTitleProps {
  title: string
  onceKey: string
  getRef?: (ref: HTMLDivElement) => void
  size?: 'large' | 'middle'
}

const BlockTitle: React.FC<BlockTitleProps> = ({
  title,
  onceKey,
  getRef,
  size = 'large',
}) => {
  return (
    <ScrollElememt
      className={classnames('block-title', size)}
      activeClassName="active"
      getRef={getRef}
      onceKey={onceKey}
    >
      <span>
        <span>{title}</span>
      </span>
    </ScrollElememt>
  )
}

export default BlockTitle
